import { createApp } from '@app/adapters/create-app'
import PdfViewerToggle from '@app/application/reconciliation_proposal/components/pdf-viewer-toggle.vue'

export default (): void => {
  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const element = doc.querySelector(
      '[data-behaviour="ai-proposal-pdf-viewer-toggle"]'
    ) as HTMLElement

    if (element) {
      const { documentsCount } = element.dataset ?? {}

      createApp(PdfViewerToggle, {
        documentsCount: documentsCount ? parseInt(documentsCount) : 1,
      }).mount(element)
    }
  })
}
